import { render, staticRenderFns } from "./BlandHero.vue?vue&type=template&id=2abeac9e&scoped=true"
import script from "./BlandHero.vue?vue&type=script&lang=js"
export * from "./BlandHero.vue?vue&type=script&lang=js"
import style0 from "./BlandHero.vue?vue&type=style&index=0&id=2abeac9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abeac9e",
  null
  
)

export default component.exports